import React, { Component } from "react";
import Select from "react-select";
import FeedbackTable from "./FeedbackTable";
import { connect } from "react-redux";
import axios from "axios";
import { HOST_URL } from "../../helpers/constants/Constants";
import { authorizedUsers } from "./AuthorisedUsers";
import { featureList } from "./FeatureList";
import FAQComponent from "./FAQComponent";
import Div100vh from "react-div-100vh/lib/Div100vh";
import TopNavbar from "../topNavbar/TopNavbar";
import PageHeader from "../../pages/pageHeader/PageHeader";
import FeedbackSummary from "../PageApps/FeedbackSummary";
class FeedbackForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: null,
      feedback: "",
    };
  }

  handleSubmit = () => {
    if (
      this.state.selectedOption === null ||
      this.props.user === 0 ||
      this.state.feedback === ""
    ) {
      alert("Please select a feature and ensure you have added some feedback");
      return;
    }

    const formData = new FormData();
    formData.append("Feature", JSON.stringify(this.state.selectedOption.value));
    formData.append("User", JSON.stringify(this.props.user.name));
    formData.append("Feedback", JSON.stringify(this.state.feedback));

    setTimeout(() => {
      axios({
        method: "post",
        url: HOST_URL + `/api/savefeedback`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          alert("Feedback submitted");
        })
        .catch((error) => {
          console.log(error);
        });
    }, 400);
  };

  handleTextChange = (elem) => {
    this.setState({
      feedback: elem.target.value,
    });
  };

  handleSelectionChange = (elem) => {
    this.setState({
      selectedOption: elem,
    });
  };

  render() {
    return (
      <div style={{ overflowY: "auto" }}>
        <Div100vh>
          <TopNavbar />
          <PageHeader src="/water-bg.jpeg" alt="water-bg" />
          <FeedbackSummary />
          <br />
          <br />
          <br />
          <br />

          {this.props.user.length !== 0 ? (
            <>
              <div>
                <div className="row justify-content-center">
                  <div
                    className="col-sm-5"
                    style={{
                      borderRight: "2px solid #6d7a80",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>
                      <h1 style={{ fontWeight: "bold" }}>Feedback Form</h1>
                    </div>

                    <div className="row align-items-centre">
                      <div style={{ marginLeft: "auto", marginRight: "auto" }}>
                        <p
                          style={{
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          Please choose which feature you are providing feedback
                          on:
                        </p>
                        <Select
                          classNamePrefix={"typeahead-select"}
                          value={this.state.selectedOption}
                          onChange={this.handleSelectionChange}
                          options={featureList.map((item) => {
                            return { value: item, label: item };
                          })}
                          getOptionLabel={(option) => option.label}
                          getOptionValue={(option) => option.value}
                          placeholder="Select feature"
                        />
                      </div>
                    </div>
                    <div className="row justify-content-center">
                      <div
                        className="justify-content-center"
                        style={{ marginLeft: "auto", marginRight: "auto" }}
                      >
                        <br />
                        <p
                          style={{
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          Please type your query or feedback in the text box
                          below:
                        </p>
                        <div className="col-12 p-0">
                          <textarea
                            className="form-control"
                            rows="3"
                            id="textArea"
                            placeholder="Type your feedback here."
                            onChange={this.handleTextChange}
                          ></textarea>
                        </div>
                        <br />
                        <div style={{ textAlign: "center" }}>
                          <button
                            type="button"
                            className="btn btn-primary col-3"
                            onClick={this.handleSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-sm-5"
                    style={{
                      borderLeft: "2px solid #6d7a80",
                    }}
                  >
                    <FAQComponent />
                  </div>
                </div>
              </div>

              <section className="container develop-content pt-5" id="content">
                <div>
                  {authorizedUsers.filter((item) => {
                    return item === this.props.user.name;
                  }).length !== 0 ? (
                    <>
                      <hr
                        style={{
                          color: "#6d7a80",
                          backgroundColor: "#6d7a80",
                          height: 2,
                          borderColor: "#6d7a80",
                        }}
                      ></hr>
                      <div>
                        <h1
                          style={{
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          Review Feedback
                        </h1>
                        <FeedbackTable />
                      </div>
                    </>
                  ) : (
                    () => {}
                  )}
                  <br />
                </div>
              </section>
            </>
          ) : (
            <div style={{ textAlign: "center" }}>
              <h1 style={{ fontWeight: "bold" }}>
                Please login <a href="/">HERE</a> to provide feedback.
              </h1>
            </div>
          )}
        </Div100vh>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.requestUserDataReducer.data,
});

export default connect(mapStateToProps)(FeedbackForm);
